import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  open(event) {
    if (event.target.closest("a")) return;
    window.open(this.element.dataset.href, "_blank");
  }
}
